import { render, staticRenderFns } from "./PaymentResult.vue?vue&type=template&id=4236e14d"
import script from "./PaymentResult.vue?vue&type=script&lang=js"
export * from "./PaymentResult.vue?vue&type=script&lang=js"
import style0 from "./PaymentResult.vue?vue&type=style&index=0&id=4236e14d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports